import React, { Component } from "react";
import BanksForm from "../BanksForm/BanksForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ReportedPage
Description : Componente que contienen el formulario de la pantalla Reported 
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas Creación – Se llama al componente ReportedForm
================================================================================ */
class BanksPage extends Component {
    render() {
        return (
            <div>
                <BanksForm />
            </div>
        )
    }
}

export default BanksPage;